import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import modifiers from '../modifiers';

const Element = ({ className, renderAs, ...allProps }) => {
  const RenderAs = renderAs || 'div';
  return <RenderAs className={classnames(className) || undefined} {...allProps} />;
};

export default Element;
